const Timezone = (client) => ({
  /**
   * @returns {Promise<any>}
   */
  find() {
    return client.get('/api/v2/open/timezone');
  },
});

export default Timezone;
